export const en = {
    from: 'From',
    to: 'To',
    reset: 'Reset',
    apply: 'Apply',
};
